type Validator = (value: any) => boolean

export interface Result {
  valid: boolean
  expectedType?: string
  nestedProperty?: string
  nestedValue?: any
}

export const wrapWithResult =
  (expectedType: string, validator: Validator) => (value: any) =>
    toResult(validator(value), expectedType)

export const toResult = (
  valid: boolean,
  expectedType?: string,
  nestedProperty?: string,
  nestedValue?: any,
) => ({
  valid,
  expectedType,
  nestedProperty,
  nestedValue,
})
